import * as Yup from 'yup';

export const cashDepositValidation = Yup.object().shape({
  documents: Yup.array().of(
    Yup.object().shape({
      sales_day: Yup.date().required('Sales day is required'),
      total_cash_sales: Yup.number()
        .positive('Total cash sales must be a positive number')
        .required('Total cash sales is required'),
      cash_deposit: Yup.number()
        .positive('Cash deposit must be a positive number')
        .max(Yup.ref('total_cash_sales'), 'Cash ≤ Total sales')
        .required('Cash deposit is required'),
      comment: Yup.string(),
      file: Yup.mixed().required('File attachment is required'),
    })
  ),
  total_cash_deposit: Yup.number()
    .positive('Total cash deposit must be a positive number')
    .required('Total cash deposit is required'),
  description: Yup.string().required('Description is required'),
});